import { SPACING_L_XS } from '@audi/audi-ui-design-tokens';
import { Icon, Text } from '@oneaudi/unified-web-components';
import { SliderActionProps } from '~/components/slider-panel/components/slider-action/models/slider-action-props';
import {
	SliderActionExpandCatalogueStyle,
	SliderActionIndicatorStyle,
	SliderActionStyle,
} from '~/components/slider-panel/components/slider-action/styles/slider-action-style';

export function SliderAction({
	active,
	sliderLength,
	navigationLeftPosition,
	slideBack,
	slideNext,
	expandCatalogue,
}: SliderActionProps) {
	return (
		<SliderActionStyle navigationLeftPosition={navigationLeftPosition} className="slider-action">
			<span className="guided-tour-slider-navigation" onClick={() => slideBack()}>
				<Icon name="back" size="s" className="asLink" />
			</span>

			<SliderActionIndicatorStyle className="slider-action-indicator">
				<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>
					<span>{active}</span>/<span>{sliderLength}</span>
				</Text>
			</SliderActionIndicatorStyle>

			<span className="guided-tour-slider-navigation" onClick={() => slideNext()}>
				<Icon name="forward" size="s" className="asLink" />
			</span>

			<SliderActionExpandCatalogueStyle
				navigationLeftPosition={SPACING_L_XS}
				className="guided-tour-slider-toggle-view slider-action-expand-catalogue"
				onClick={() => expandCatalogue()}>
				<Icon name="catalogue" size="s" className="asLink" />
			</SliderActionExpandCatalogueStyle>
		</SliderActionStyle>
	);
}
